exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-nav-desktop-sub-menu[data-v-0ee1c9a5] {\n  padding: 1em 0;\n}\n.site-nav-desktop-sub-menu li.sub-menu-item[data-v-0ee1c9a5] {\n  padding: 0.5em 0;\n}\n", ""]);

// exports
